<template>
  <div>
    <div
      class="font-bold text-center text-[1rem] xxs:text-[1.125rem] md:text-[1.25rem] lg:text-[1.5rem] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.75rem] uppercase"
      :class="hasPast ? pastClass : futureDateClass"
    >
      <div
        class="block font-medium text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] leading-[1rem] md:leading-[1.25rem] lg:leading-[1.5rem] mt-[4px]"
        :class="hasPast ? pastClass : futureDayClass"
      >
        <span v-if="startDate == endDate">{{ formatDay(startDate) }}</span>
        <span
          :class="{ 'bg-[#FEC629]': !hasPast }"
          v-if="startDate != endDate && formatMonth(startDate) == formatMonth(endDate)"
        >
          {{ formatDay(startDate) }} - {{ formatDay(endDate) }}
        </span>
        <span
          :class="{ 'bg-[#FEC629]': !hasPast }"
          v-if="formatMonth(startDate) != formatMonth(endDate)"
        >
          {{ formatDay(startDate) }} - {{ formatDay(endDate) }}
        </span>
      </div>
      <div
        class="text-[1rem] md:text-[1.25rem] lg:text-[1.5rem] font-inter font-bold"
        v-if="startDate == endDate"
      >
        {{ formatDateNumber(startDate) }}
      </div>
      <div
        class="text-[1rem] md:text-[1.25rem] lg:text-[1.5rem] font-inter font-bold"
        v-if="startDate != endDate && formatMonth(startDate) == formatMonth(endDate)"
      >
        {{ formatDateNumber(startDate) }} - {{ formatDateNumber(endDate) }}
      </div>
      <div
        class="text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] font-bold"
        v-if="
          startDate == endDate ||
          (startDate != endDate && formatMonth(startDate) == formatMonth(endDate))
        "
      >
        {{ formatMonth(startDate) }}
      </div>
      <div
        v-if="formatMonth(startDate) != formatMonth(endDate)"
        class="flex items-center justify-center gap-[5px]"
      >
        <div class="text-[1rem] md:text-[1.25rem] lg:text-[1.5rem] font-inter font-bold">
          {{ formatDateNumber(startDate) }}
          <div class="text-[0.75rem] font-bold block">{{ formatMonth(startDate) }}</div>
        </div>
        <span class="text-[1rem] md:text-[1.25rem] lg:text-[1.5rem] font-inter font-bold">-</span>
        <div class="text-[1rem] md:text-[1.25rem] lg:text-[1.5rem] font-inter font-bold">
          {{ formatDateNumber(endDate) }}
          <div class="text-[0.75rem] font-bold block">{{ formatMonth(endDate) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    hasPast: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pastClass: 'text-[#7C7B78]',
      futureDateClass: 'text-[#0B0C0F]',
      futureDayClass: 'text-[#3C3A36]',
    };
  },
  methods: {
    formatDateNumber(date) {
      if (typeof date === 'string') {
        return dayjs(date).format('D');
      }

      return `${dayjs(date.start).format('D')} - ${dayjs(date.end).format('D')}`;
    },
    formatDay(date) {
      if (typeof date === 'string') {
        return dayjs(date).format('ddd');
      }

      return `${dayjs(date.start).format('ddd')} - ${dayjs(date.end).format('ddd')}`;
    },
    formatMonth(date) {
      if (typeof date === 'string') {
        return dayjs(date).format('MMM');
      }

      return dayjs(date.start).format('MMM');
    },
  },
};
</script>
